<template>
  <el-container style="height: 100%;">
    <el-header>
      <slot name="header"></slot>
    </el-header>
    <el-container>
      <el-main>
        <slot name="main"></slot>      
      </el-main>
      <el-aside>
        <slot name="aside"></slot>      
      </el-aside>
    </el-container>
  </el-container>
</template>

<script>
    export default {
      name: 'LayoutLogin'
    }
</script>

<style scoped>

</style>
